import apm from '@/utils/templates/apm.template';
import apmCharts from '@/utils/templates/apm.dashboard.charts.template';
import browserCharts from '@/utils/templates/browser.charts.template';
import vmCharts from '@/utils/templates/vm.charts.template';
import mobileCharts from '@/utils/templates/mobile.charts.template';
import databaseCharts from '@/utils/templates/database.charts.template';
import wsmCharts from '@/utils/templates/wsm.charts.template';
import smCharts from '@/utils/templates/sm.charts.template';
import logCharts from '@/utils/templates/log.charts.template';
import { vendors } from '@/utils/templates/cloudTemplates/integration.config';
import alert from '@/utils/templates/alert.template';
import alertsV2 from '@/utils/templates/alertsV2.template';
import notification from '@/utils/templates/notification.template';
import home from '@/utils/templates/home.template';
import homeCharts from '@/utils/templates/home.template.charts';
import help from '@/utils/templates/help.template';
import integrations from '@/utils/templates/integrations';
import cloud from '@/utils/templates/cloud';
import cloudTemplate from '@/utils/templates/cloud.template';
import digitalExperience from '@/utils/templates/digitalExperience';
import mqCharts from '@/utils/templates/mq.charts.template';

import {
  CAPABILITY_APM,
  CAPABILITY_BROWSER,
  CAPABILITY_MOBILE,
  CAPABILITY_DATABASE,
  CAPABILITY_VM,
  TEMPLATE_VM,
  CAPABILITY_WSM,
  TEMPLATE_WSM,
  CAPABILITY_SM,
  CAPABILITY_K8M,
  TEMPLATE_INTEGRATIONS,
  CAPABILITY_INTEGRATIONS,
  CAPABILITY_CLOUD,
  TEMPLATE_CLOUD_SVC,
  CAPABILITY_LOG,
  CAPABILITY_MQ,
  CAPABILITY_USAGE,
  CAPABILITY_ANALYTICS,
  TEMPLATE_LOADING_PAGE,
  CAPABILITY_DE,
  CAPABILITY_HOME,
} from '@/utils/constants';
import {
  TEMPLATE_HOME,
  TEMPLATE_APM,
  TEMPLATE_ALERT,
  TEMPLATE_ALERTS_V2,
  TEMPLATE_NOTIFICATION,
  TEMPLATE_BROWSER,
  TEMPLATE_SETTINGS,
  TEMPLATE_DATABASE,
  TEMPLATE_SM,
  TEMPLATE_HELP,
  TEMPLATE_MOBILE,
  TEMPLATE_K8M,
  TEMPLATE_LOG,
  TEMPLATE_ANALYTICS,
  TEMPLATE_DE,
  TEMPLATE_BILLING_USAGE,
  TEMPLATE_MQ,
  TEMPLATE_AWS,
} from '@/utils/constants';

import { CORRELATED_CAPABILITIES_APM } from '@/utils/constants';

import settings from '@/utils/templates/settings.template';
import browser from '@/utils/templates/browser.template';
import vm from '@/utils/templates/vm.template';
import mobile from '@/utils/templates/mobile.template';
import database from '@/utils/templates/database.template';
import wsm from '@/utils/templates/wsm.template';
import sm from '@/utils/templates/sm.template';
import k8m from '@/utils/templates/k8m.template';
import log from '@/utils/templates/log.template';
import datausage from '@/utils/templates/billing.usage.template';
import analytics from '@/utils/templates/analytics.template';
import mq from '@/utils/templates/mq.template';
import loadingPage from '@/utils/templates/loading.template';

import { MutationTree } from 'vuex';
import { State } from './app.store';
import awsTemplates from '@/utils/templates/cloud.aws.charts.template';

const mutations: MutationTree<State> = {
  setTemplate(state: State, template: any) {
    switch (template) {
      case TEMPLATE_HOME:
        state.currentSideNav = home;
        state.chartsTemplate = homeCharts;
        state.currentCapability = CAPABILITY_HOME;
        break;
      case TEMPLATE_ALERT:
        state.currentSideNav = alert;
        // state.currentCapability = CAPABILITY_MOBILE;
        break;
      case TEMPLATE_ALERTS_V2:
        state.currentSideNav = alertsV2;
        break;
      case TEMPLATE_NOTIFICATION:
        state.currentSideNav = notification;
        break;
      case TEMPLATE_APM:
        state.currentSideNav = apm;
        state.chartsTemplate = apmCharts;
        state.currentCapability = CAPABILITY_APM;
        break;
      case TEMPLATE_DATABASE:
        state.currentSideNav = database;
        state.chartsTemplate = databaseCharts();
        state.currentCapability = CAPABILITY_DATABASE;
        break;
      case TEMPLATE_SM:
        state.currentSideNav = sm;
        state.chartsTemplate = smCharts;
        state.currentCapability = CAPABILITY_SM;
        break;
      case TEMPLATE_BROWSER:
        state.currentSideNav = browser;
        state.chartsTemplate = browserCharts;
        state.currentCapability = CAPABILITY_BROWSER;
        break;
      case TEMPLATE_VM:
        state.currentSideNav = vm;
        state.currentCapability = CAPABILITY_VM;
        state.chartsTemplate = vmCharts;
        break;
      case TEMPLATE_MOBILE:
        state.currentSideNav = mobile;
        state.currentCapability = CAPABILITY_MOBILE;
        state.chartsTemplate = mobileCharts;
        break;
      case TEMPLATE_WSM:
        state.currentSideNav = wsm;
        state.chartsTemplate = wsmCharts;
        state.currentCapability = CAPABILITY_WSM;
        break;
      case TEMPLATE_K8M:
        state.currentSideNav = k8m;
        state.currentCapability = CAPABILITY_K8M;
        break;
      case TEMPLATE_SETTINGS:
        state.currentSideNav = settings;
        break;
      case TEMPLATE_HELP:
        state.currentSideNav = help;
        break;
      case TEMPLATE_INTEGRATIONS:
        state.chartsTemplate = vendors;
        state.currentCapability = CAPABILITY_INTEGRATIONS;
        state.currentSideNav = integrations;
        break;
      case TEMPLATE_CLOUD_SVC:
        state.currentCapability = CAPABILITY_CLOUD;
        state.currentSideNav = cloud;
        state.chartsTemplate = cloudTemplate;
        break;
      case TEMPLATE_LOG:
        state.currentSideNav = log;
        state.currentCapability = CAPABILITY_LOG;
        state.chartsTemplate = logCharts;
        break;
      case TEMPLATE_ANALYTICS:
        state.currentSideNav = analytics;
        state.currentCapability = CAPABILITY_ANALYTICS;
        break;
      case TEMPLATE_DE:
        state.currentSideNav = digitalExperience;
        state.currentCapability = CAPABILITY_DE;
        break;
      case TEMPLATE_BILLING_USAGE:
        state.currentSideNav = datausage;
        state.currentCapability = CAPABILITY_USAGE;
        break;
      case TEMPLATE_MQ:
        state.currentSideNav = mq;
        state.currentCapability = CAPABILITY_MQ;
        state.chartsTemplate = mqCharts;
        break;
      case TEMPLATE_LOADING_PAGE:
        state.currentSideNav = loadingPage;
        break;
      default:
        state.currentSideNav = home;
        break;
    }
  },
  setChartsTemplate(state: State, template: any) {
    switch (template) {
      case TEMPLATE_APM:
        state.chartsTemplate = apmCharts;
        break;
      case TEMPLATE_DATABASE:
        state.chartsTemplate = databaseCharts();
        break;
      case TEMPLATE_SM:
        state.chartsTemplate = smCharts;
        break;
      case TEMPLATE_BROWSER:
        state.chartsTemplate = browserCharts;
        break;
      case TEMPLATE_VM:
        state.chartsTemplate = vmCharts;
        break;
      case TEMPLATE_MOBILE:
        state.chartsTemplate = mobileCharts;
        break;
      case TEMPLATE_WSM:
        state.chartsTemplate = wsmCharts;
        break;
      case TEMPLATE_INTEGRATIONS:
        state.chartsTemplate = vendors;
        break;
      case TEMPLATE_CLOUD_SVC:
        state.chartsTemplate = cloudTemplate;
        break;
      case TEMPLATE_LOG:
        state.chartsTemplate = logCharts;
        break;
      case TEMPLATE_MQ:
        state.chartsTemplate = mqCharts;
        break;
      default:
        state.currentSideNav = home;
        break;
    }
  },
  toggleMenu(state: State) {
    state.openMenu = !state.openMenu;
  },
  setUpdateDasboard(state: State, data: any) {
    state.updateDashboard = data;
  },
  setchartsTemplate(state: State, data: any) {
    state.chartsTemplate = data;
  },
  setActiveCapabilities(state: State, value: Array<any>) {
    state.activeCapabilities = value;
  },
  setCurrentCapability(state: State, capability: string) {
    switch (capability) {
      case CAPABILITY_APM:
        state.currentCapability = CAPABILITY_APM;
        break;
      case CAPABILITY_BROWSER:
        state.currentCapability = CAPABILITY_BROWSER;
        break;
      case CAPABILITY_MOBILE:
        state.currentCapability = CAPABILITY_MOBILE;
        break;
      case CAPABILITY_DATABASE:
        state.currentCapability = CAPABILITY_DATABASE;
        break;
      case CAPABILITY_SM:
        state.currentCapability = CAPABILITY_SM;
        break;
      case CAPABILITY_K8M:
        state.currentCapability = CAPABILITY_K8M;
        break;
      case CAPABILITY_VM:
        state.currentCapability = CAPABILITY_VM;
        break;
      case CAPABILITY_LOG:
        state.currentCapability = CAPABILITY_LOG;
        break;
      case CAPABILITY_DE:
        state.currentCapability = CAPABILITY_DE;
        break;
      case CAPABILITY_MQ:
        state.currentCapability = CAPABILITY_MQ;
        break;
      case CAPABILITY_USAGE:
        state.currentCapability = CAPABILITY_USAGE;
        break;
      default:
        state.currentCapability = CAPABILITY_APM;
        break;
    }
  },
  setCorrelatedCapability(state: State, correlatedCapability: string) {
    switch (correlatedCapability) {
      case CORRELATED_CAPABILITIES_APM:
        state.correlatedCapability = CORRELATED_CAPABILITIES_APM;
        break;
      default:
        state.correlatedCapability = '';
        break;
    }
  },
  setHideDateTimePicker(state: State, value: Boolean) {
    state.hideDateTimePicker = value;
  },
  setDisableDateTimePickerOptions(state: State, value: Array<any>) {
    state.disableDateTimePickerOptions = value;
  },
  setIsFormOpened(state: State, value: boolean) {
    state.isFormOpened = value;
  },
  setIsForcastEnabled(state: State, data: any) {
    state.isForcastEnabled = data;
    state.isCompareCalendarEnabled = !data;
  },
  setIsCompareCalendarEnabled(state: State, data: any) {
    state.isCompareCalendarEnabled = data;
    state.isForcastEnabled = !data;
  },
  setIsForecastModalEnable(state: State, data: any) {
    state.isForecastModalEnable = data;
  },
  setCurrLang(state: State, data: any) {
    state.currLang = data;
  },
  setPermissions(state: State, data: any = null) {
    state.permissions = data;
  },
  setMiddlewareLoading(state: State, data: any = null) {
    state.middlewareLoading = data;
  },
};

export default mutations;

// export const mutations = {

// };
